"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const layout = {
    contentWidth: '75rem',
    contentPaddingHorizontal: '1rem'
};
exports.default = layout;
//# sourceMappingURL=layout.js.map